(ns teamoesterreich.user-mode.profile.profile-notifications
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.expand-less :refer [expand-less]]
    [reagent-material-ui.icons.expand-more :refer [expand-more]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]


    [reagent.core :as r]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.util.log :as log]))



(defn unParseDateFieldToTimestamp [ts]
  (let [date (if ts (.toDate ^js ts) (js/Date.))]
    (goog.string.format "%04d-%02d-%02d %02d:%02d" (.getFullYear date) (inc (.getMonth date)) (.getDate date) (.getHours date) (.getMinutes date))
    ))


(defonce TYPES {"sms"   "SMS"
                "push"  "Push"
                "email" "Email"
                })


(defn message-block [type title date message]
  (let [!st (r/atom {:open false})]
    (fn []
      [mui/grid
       {:container false
        :xs        12                                       ;extra-small: 0px
        :style     {:padding "15px 15px 0 15px"}
        }
       [mui/card
        {:variant "outlined"}
        [mui/card-actions
         [mui/grid
          {:container  true
           :item       false
           :alignItems "flex-start"
           :justify    "flex-start"
           :spacing    1
           :style      {:padding "5px"}
           }

          [mui/grid
           {:item true
            :xs   8
            }
           [mui/typography {:variant "body1" :gutterBottom true}
            date " " (or (get TYPES type) "")
            [:div {:style {:display "inline_block"}}]]
           ]
          [mui/grid
           {:item  true
            :xs    4
            :style {:text-align "right"}
            }
           [mui/button {:size    "small" :color "secondary"
                        :endIcon (r/as-element (if (:open @!st) [expand-less] [expand-more]))
                        :onClick (fn [] (log/out "message-block click" (:open @!st)) (swap! !st assoc :open (not (:open @!st))))
                        } (if (:open @!st) "Fertig" "Lesen ...")]
           ]
          [mui/grid
           {:item true
            :xs   12
            }
           [mui/typography {:variant "h6" :component "h6"} title]
           ]

          ]]
        [mui/collapse {:in (:open @!st) :timeout "auto"}
         [mui/card-content {

                            }
          [:div {:dangerouslySetInnerHTML {:__html message}}]

          ]

         ]

        ]
       ]
      )))


(defn get-it []
  (let [!actual-user (r/cursor store/app-state [:actual-user])
        !messages (r/cursor store/app-state [:messages])]
    (a/set-bottom-action-fn #(a/set-page-back))
    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:container false
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"
                          }}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1
          "Mein Postfach"]
         [:span "Im Laufe deiner Zeit als Mitglied werden wir immer wieder mit dir in Kontakt treten. Hier kannst du alle Nachrichten nachlesen."]

         ]
        ;(log/out "######################### !messages" @!messages)

        (for [{:keys [key date date-str message title type]} (reverse (sort-by :date-str (map (fn [[k d]] (assoc d :key k :date-str (unParseDateFieldToTimestamp (:date d)))) @!messages)))]
          ^{:key (str "message-" key)} [message-block type title date-str message]
          )

        [mui/grid
         {:container false
          :md        5                                      ;medium: 960px
          :xs        5                                      ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :style     {:margin "10px 0 10px 10px" :width "200px"}
           :onClick   #(a/set-page-back)
           :startIcon (r/as-element [keyboard-arrow-left])
           }
          "Zurück"]

         ]

        ]]]]
    ))